/** @module */

/**
 * @enum {string}
 * @includevals
 */
export const sceneTypes = {
    pano: 'pano',
    flat: 'flat',
};